export default {
  computed: {
    headers () {
      return [
        {
          text: 'Sequência',
          value: 'sequencia',
          width: '140px',
          filtros: []
        },
        {
          text: 'Título',
          value: 'titulo',
          filtros: []
        },
        {
          text: 'Subtítulo',
          value: 'subtitulo',
          filtros: []
        },
        {
          text: 'Descrição',
          value: 'descricao',
          filtros: []
        },
        {
          text: 'Ícone',
          value: 'icone',
          filtros: []
        },
        {
          text: 'Aplicação',
          value: 'aplicacao',
          filtros: []
        },
        {
          text: 'Ativo',
          value: 'ativo',
          filtros: []
        }
      ]
    }
  }
}
